import React, {Profiler, ProfilerOnRenderCallback, ReactNode} from "react";
import {Lifetime, LifetimeSequence} from "../../util/Lifetime";
import {getOrSet} from "../../util/MapUtil";
import {delayed} from "../../util/concurrency/Delay";
import {Logger} from "../../util/Logger";


class LogProfilerModel {
    profilers = new Map<string, {
        id: string;
        lifetimeSequence: LifetimeSequence,
        buffer: {
            phase: string;
            actualDuration: number;
            baseDuration: number;
            startTime: number;
            commitTime: number;
        }[],
    }>();

    log = Logger("LogProfiler");

    logRender: ProfilerOnRenderCallback = (id, phase, actualDuration, baseDuration, startTime, commitTime) => {
        const profiler = getOrSet(this.profilers, id, () => ({
            id,
            lifetimeSequence: new LifetimeSequence(Lifetime.Infinite),
            buffer: [],
        }));

        profiler.buffer.push({
            phase,
            actualDuration,
            baseDuration,
            startTime,
            commitTime,
        });

        const timeoutLifetime = profiler.lifetimeSequence.next();
        delayed(2_000, timeoutLifetime, () => {
            const total = profiler.buffer
                .map(({actualDuration}) => actualDuration)
                .reduce((a, b) => a + b);
            this.log.info(`[performance]: ${id}`, `${total}ms`, profiler.buffer)
            this.profilers.delete(id);
        });
    }
}

const logProfilerModel = new LogProfilerModel();

export function LogProfiler({id, children}: {
    id: string,
    children: ReactNode,
}) {
    return (
        <Profiler id={id} onRender={logProfilerModel.logRender}>
            {children}
        </Profiler>
    );
}